const data = [
    'Level-1',
    'Level-2',
    'Level-3',
    'Complete'
  ];

export default data;